import { Alert, AlertDescription } from '@/shared/components/ui/Alert';
import { AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const PendingFeedbackAlert = () => {
  const { t } = useTranslation('interactions');

  return (
    <Alert className="bg-orange-50 border-orange-200 shadow-sm">
      <AlertCircle className="h-4 w-4 text-orange-600" />
      <AlertDescription className="text-orange-900 font-medium">
        {t('pendingFeedbackAlert')}
      </AlertDescription>
    </Alert>
  );
};
